import { Spin } from "antd";
import { FileOutlined, CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";
import styles from "./styles.module.less";

interface FilePreviewProps {
  fileName: string;
  isUploading: boolean;
  onRemove?: () => void;
}

export const FilePreview = ({
  fileName,
  isUploading,
  onRemove,
}: FilePreviewProps) => {
  return (
    <div className={styles.attachmentInfo}>
      <div className={styles.fileIconWrapper}>
        <div className={styles.fileIcon}>
          {isUploading ? <Spin size="small" /> : <FileOutlined />}
        </div>
      </div>
      <div className={styles.fileInfo}>
        <span className={styles.fileName}>{fileName}</span>
        <span className={styles.fileType}>Tệp đính kèm</span>
      </div>
      {!isUploading && onRemove && (
        <Button
          type="text"
          icon={<CloseOutlined />}
          className={styles.removeButton}
          onClick={onRemove}
        />
      )}
    </div>
  );
};
